"use client";

import { useEffect } from 'react';

export default function CreditsJS() {
  useEffect(() => {
    console.log('<!-- ----------------------------------------------------- -->\n' +
      '<!-- Code by AMA, http://ama.work (2025) -->\n' +
      '<!-- ----------------------------------------------------- -->');
  }, [])

  return (
    <></>
  );
}